module.exports = __webpack_public_path__ + "static/media/10.1be0e8eb.mp3";